export const init = () => {
    const blocks = document.querySelectorAll('.faq');

    blocks.forEach(block => {
        const items = block.querySelectorAll('.faq__item');
        
        items.forEach(item => {
            const question = item.querySelector('.faq__item-question');
            const answer = item.querySelector('.faq__item-answer');
            
            if (!question || !answer) return;

            question.addEventListener('click', () => {
                const isActive = item.classList.contains('is-active');
                
                // Toggle current item
                if (isActive) {
                    item.classList.remove('is-active');
                    question.setAttribute('aria-expanded', 'false');
                    jQuery(answer).slideUp(300);
                } else {
                    // Option to close other items
                    const activeItem = block.querySelector('.faq__item.is-active');
                    if (activeItem && activeItem !== item) {
                        activeItem.classList.remove('is-active');
                        const activeQuestion = activeItem.querySelector('.faq__item-question');
                        if (activeQuestion) {
                            activeQuestion.setAttribute('aria-expanded', 'false');
                        }
                        jQuery(activeItem.querySelector('.faq__item-answer')).slideUp(300);
                    }

                    item.classList.add('is-active');
                    question.setAttribute('aria-expanded', 'true');
                    jQuery(answer).slideDown(300);
                }
            });
        });
    });
};
